export const whatsappLink = "https://wa.link/l8xa41";
export const instagramLink = "https://instagram.com/instadrop.ng";
export const telegramLink = "https://t.me/joinchat/KLiG60EhqJplYzRk";
export const facebookLink = "https://www.facebook.com/";
export const twitterLink = "https://twitter.com";
